import styled from 'styled-components/macro'
import Box from 'components/shared/Box'
import Grid from 'components/shared/Grid'

export const OpeningHoursMobileWrapper = styled(Box)`
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.grayscale_200};
    width: 100%;
    max-width: 100%;

    > div {
        background-color: ${({ theme }) => theme.colors.grayscale_0};
        border-radius: 8px;
        padding: 18px 16px;
    }

    ul {
        width: 100%;
    }

    li {
        &:not(:first-child) {
            margin-top: 12px;
        }
    }
`
export const OpeningHoursWrapper = styled(Grid)`
    border-radius: 8px;
    background-color: ${({ theme }) => theme.colors.grayscale_0};
    width: 100%;
    max-width: 100%;

    ul {
        width: 100%;
    }

    li {
        &:not(:first-child) {
            margin-top: 12px;
        }
    }
`
